'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import emptyFunction from 'react-utils/emptyFunction';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import { EERIE } from 'HubStyleTokens/colors';
import LearningMaterial from 'academy-shared-js/records/LearningMaterial';
import { LearningMaterialTypes } from 'academy-shared-js/constants/ContentConstants';
import { Link } from '../AcademyLinks';

class ResourcesList extends PureComponent {
  constructor(props) {
    super(props);
    this.maybeRenderResourceWithIcon = this.maybeRenderResourceWithIcon.bind(this);
    this.renderAdditionalResource = this.renderAdditionalResource.bind(this);
  }

  maybeRenderResourceWithIcon(url, icon, i18nLabelSuffix) {
    const {
      onResourceClick
    } = this.props;

    if (!url) {
      return null;
    }

    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-2",
        color: EERIE,
        name: icon,
        size: "xxs"
      }), /*#__PURE__*/_jsx(Link, {
        external: true,
        href: url,
        onClick: (...partialArgs) => onResourceClick({
          title: i18nLabelSuffix,
          url
        }, ...partialArgs),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.resources.${i18nLabelSuffix}`
        })
      })]
    });
  }

  renderAdditionalResource(resource, index) {
    const {
      onResourceClick
    } = this.props;
    const type = resource.get('type');
    const title = resource.get('title');
    const url = resource.get('targetUrl');
    const isKnownType = !!LearningMaterialTypes[type];

    if (!isKnownType) {
      Raven.captureMessage(`[Additional Resources] Unknown type: ${type}`);
    }

    return /*#__PURE__*/_jsxs("div", {
      children: [isKnownType ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.resources.type.${type}`
      }) : {
        type
      }, ":\xA0", /*#__PURE__*/_jsx(Link, {
        external: true,
        href: url,
        onClick: (...partialArgs) => onResourceClick({
          title,
          url
        }, ...partialArgs),
        children: title
      })]
    }, index);
  }

  render() {
    const {
      additionalResources,
      className,
      i18nHeading,
      i18nNoResources,
      slidesUrl,
      transcriptUrl
    } = this.props;

    if (!slidesUrl && !transcriptUrl && additionalResources.isEmpty()) {
      return /*#__PURE__*/_jsx("h5", {
        className: className,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nNoResources
        })
      });
    }

    return /*#__PURE__*/_jsxs("div", {
      className: className,
      children: [/*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nHeading
        })
      }), /*#__PURE__*/_jsxs(UIList, {
        children: [this.maybeRenderResourceWithIcon(slidesUrl, 'documents', // TODO - waiting on an actual icon for this https://git.hubteam.com/HubSpot/UIComponents/issues/4667
        'downloadSlides'), this.maybeRenderResourceWithIcon(transcriptUrl, 'documents', 'downloadTranscript'), additionalResources.map(this.renderAdditionalResource)]
      })]
    });
  }

}

ResourcesList.propTypes = {
  additionalResources: ImmutablePropTypes.listOf(LearningMaterial),
  className: PropTypes.string,
  i18nHeading: PropTypes.string.isRequired,
  i18nNoResources: PropTypes.string.isRequired,
  onResourceClick: PropTypes.func.isRequired,
  slidesUrl: PropTypes.string,
  transcriptUrl: PropTypes.string
};
ResourcesList.defaultProps = {
  additionalResources: List(),
  onResourceClick: emptyFunction
};
export default ResourcesList;